import {
  data as demandeStatus
} from '@lba-dev/package.local-globals/demandeStatus';
import {
  data as categories
} from '@lba-dev/package.local-globals/categories';
import { S_INT } from '@lba-dev/package.local-globals/services';
import {
  demandePriorityStatus
} from '@lba-dev/package.local-globals/demandePriorityStatus';

import { Types } from '../../utils/List/Types';
import { callBackFunction } from '../../components/Utils/ListFunctions';
import { getAllSourceOfDemande } from '../../actions/demande';
import notifSystem from '../../notifSystem';

const loadSources = () => getAllSourceOfDemande()
  .then(sources => sources.map(source => ({
    label: source,
    value: source
  })))
  .catch(() => {
    notifSystem.error(
      'Erreur',
      'Impossible de charger les sources'
    );
    return [];
  });

export const listData = ({ user, users }) => {
  switch (user.service) {
    case S_INT: {
      const columns = {
        table: {
          '': Types.SelectForCampaign,
          Source: Types.Text,
          Telepro: Types.Text,
          Categorie: Types.DemandeCat,
          Client: Types.DemandeClient,
          Date: Types.Date,
          Appel: Types.Date,
          S_Choix: Types.Text,
          Choix: Types.Text,
          'Code postal': Types.DemandeZipCode,
          Statut: Types.Rectangle,
          'Rendez-vous': Types.Icon,
          Priorité: Types.Icon,
        },
        tableData: [
          { class: '' },
          {
            class: '',
            type: 'select',
            data: loadSources
          },
          { class: 'cat', list: users, key: 'login' },
          { class: 'cat', list: categories },
          { class: 'th' },
          { class: '' },
          { class: '' },
          { class: '' },
          { class: '' },
          { class: '' },
          { class: '', list: demandeStatus },
          { class: '' },
          {
            class: 'centerText',
            type: 'select',
            data: demandePriorityStatus.datasets,
            chip: demandePriorityStatus.chip
          }
        ],
        keys: [
          '',
          'source',
          'login.ajout',
          'categorie',
          [
            'client.civility', 'client.name',
            'client.firstname', 'client.fullName'
          ],
          'date.ajout',
          'date.firstCall',
          'choice',
          'sChoice',
          'client.zipCode',
          'status',
          'date.meeting',
          'isPriority',
        ],
        checkType: [
          '',
          'source',
          'users',
          'categorie',
          ['client.civility', 'client.name',
            'client.firstname', 'client.fullName'],
          'date',
          'firstCall',
          'choice',
          'sChoice',
          'client.zipCode',
          'dStatus',
          'dateMeeting',
          'isPriority'
        ],
      };
      return columns;
    }
    default: {
      return {
        table: {
          '': Types.SelectForCampaign,
          Source: Types.Text,
          Telepro: Types.Text,
          Categorie: Types.DemandeCat,
          Client: Types.DemandeClient,
          Date: Types.Date,
          Appel: Types.Date,
          S_Choix: Types.Text,
          Choix: Types.Text,
          'Code postal': Types.DemandeZipCode,
          Statut: Types.Rectangle,

        },
        tableData: [
          { class: '' },
          {
            class: '',
            type: 'select',
            data: loadSources
          },
          { class: 'cat', list: users, key: 'login' },
          { class: 'cat', list: categories },
          { class: 'th' },
          { class: '' },
          { class: '' },
          { class: '' },
          { class: '' },
          { class: '' },
          { class: '', list: demandeStatus },
        ],
        keys: [
          '',
          'source',
          'login.ajout',
          'categorie',
          ['client.civility', 'client.name',
            'client.firstname', 'client.fullName'],
          'date.ajout',
          'date.firstCall',
          'choice',
          'sChoice',
          'client.zipCode',
          'status',

        ],
        checkType: [
          '',
          'source',
          'users',
          'categorie',
          ['client.civility', 'client.name',
            'client.firstname', 'client.fullName'],
          'date',
          'firstCall',
          'choice',
          'sChoice',
          'client.zipCode',
          'dStatus',
        ],
      };
    }
  }
}

export const functionType = [
  {
    type: 'source',
    callback: callBackFunction.source,
  },
  {
    type: 'categorie',
    callback: callBackFunction.categorie,
  },
  {
    type: 'dStatus',
    callback: callBackFunction.dStatus,
  },
  {
    type: 'firstCall',
    callback: callBackFunction.firstCall,
  },
  {
    type: 'choice',
    callback: callBackFunction.choice,
  },
  {
    type: 'sChoice',
    callback: callBackFunction.sChoice,
  },
  {
    type: 'client.zipCode',
    callback: callBackFunction.clientZipCode,
  },
  {
    type: 'dateMeeting',
    callback: callBackFunction.dateMeeting,
  },
  {
    type: 'isPriority',
    callback: callBackFunction.isPriority,
  },
];

export const format = (demande) => ({
  ...demande,
  id: demande._id,
  externalId: demande.id
});

export const project = [
  '_id',
  'comments',
  'messages.dumb',
  'artisans.status',
  'called',
  'groups',
  'intervention',
  'devis',
  'login',
  'source',
  'client',
  'date',
  'choice',
  'sChoice',
  'status',
  'reminders',
  'createdFrom',
  'artisan',
  'billing',
  'products',
  'onSitePayment',
  'description',
  'dropbox',
  'categorie',
  'consignes',
  'context',
  'flexHour',
  'flexDate',
  'definHClient',
  'definDClient',
  'infoDesc',
  'pdfName',
  'finalPrice',
  'id',
  'statusSignature',
  'currentArtisan',
  'raisonRefus',
  'takeOver',
  'isPriority',
  'archived',
];
